/**
 * Regula Legal ID Verification Page — rendered at /:locale/regula-legal-id-verification.
 * Parallel to LegalIdVerificationPage (Veriff). Wrapper for the Regula orchestrator.
 */
import { RegulaLegalIdVerification } from "../components/regulaLegalIdVerification/RegulaLegalIdVerification";

export function RegulaLegalIdVerificationPage() {
  return <RegulaLegalIdVerification />;
}
